<template>
  <pc class="pc"></pc>
  <mobile class="mobile"></mobile>
</template>

<script>
import pc from "./pc";
import mobile from "./mobile";
export default {
  components: {
    pc,
    mobile,
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1201px) {
  .mobile {
    display: none;
  }
}
</style>
<style scoped lang="scss">
@media screen and (max-width: 1200px) {
  .pc {
    display: none;
  }
}
</style>

